// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"dc4cdb76","796":"1341d775"}[chunkId] + ".chunk.js";
};